import React from "react";
import { Provider } from "react-redux";
import ReactDOM from "react-dom/client";
import App from "./App";
import store from "./Store/store";

import { ToastContainer } from "react-toastify";

import "./Assets/index.css";

import "react-date-picker/dist/DatePicker.css";
import { BrowserRouter } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
    <ToastContainer autoClose={3000} />
  </React.StrictMode>
);
